const jobsMixin = {
  methods: {
    async apiJobSave (job, $axios = null) {
      const params = { job }
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/save', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiJobGetJobs (page = 1, getAllOpen = false, $axios = null) {
      const params = { page }
      if (!!getAllOpen) {
        params.all_open = !!getAllOpen
      }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/list', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobSearchJobs (filter, $axios = null) {
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/search', { params: filter }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobGetJob (juid, $axios = null) {
      const params = { juid }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/get', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobGetJobInfo (juid, $axios = null) {
      const params = { juid }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/info', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobFetchBid (juid, $axios = null) {
      const params = { juid }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/bid', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobSubmitBid (juid, job, $axios = null) {
      const params = { ...job }
      params.juid = juid
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/bid', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiJobGetMyBids (page = 1, $axios = null) {
      const params = { page }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/bids', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobGetBids (juid, page = 1, $axios = null) {
      const params = { juid, page }
      $axios = $axios ?? this.$axios
      return await $axios.get('/jobs/bids-public', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiJobAcceptBid (buid, $axios = null) {
      const params = { buid }
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/bid-accept', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiJobRejectBid (buid, $axios = null) {
      const params = { buid }
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/bid-reject', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobDeleteJob (juid, $axios = null) {
      const params = { juid }
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/delete', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobFavoriteJob (juid, doFav, $axios = null) {
      const params = { juid }
      $axios = $axios ?? this.$axios
      return await $axios.post(doFav ? '/jobs/favorite' : '/jobs/unfavorite', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },

    async apiJobInviteContractor (juid, uuid, $axios = null) {
      const params = { juid, uuid }
      $axios = $axios ?? this.$axios
      return await $axios.post('/jobs/invite', params).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    }
  }
}

export default jobsMixin
